// @ts-strict-ignore
import {Component} from 'panel';

import {addToast} from 'common/components/toast-area/toast-manager';
import {reporter} from 'common/report/error-reporting';
import {ToastType} from 'common/components/toast/types';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {initOptimizely, optInOptimizely, optOutOptimizely} from 'common/util/optimizely';
import {setOptState} from 'iron/gdpr/opt';
import {loadIsGdpr} from 'iron/gdpr';

import {template} from './template';
import css from './index.styl?inline';

interface CPRAPreferencesState {
  optStatus: `in` | `out`;
}

export class CPRAPreferences extends Component<CPRAPreferencesState> {
  get config() {
    return {
      css,
      useShadowDom: true,
      template,
      defaultState: {
        optStatus: null,
      },
      helpers: {
        handleSwitchChange: async (optStatus: `in` | `out`) => {
          const trackingResponse = await setOptState(optStatus, `tracking`);
          const storageResponse = await setOptState(optStatus, `storage`);
          if (trackingResponse.success && storageResponse.success) {
            addToast({type: ToastType.SUCCESS, message: `CPRA preferences updated`});
            this.update({optStatus});
            if (optStatus === `out`) {
              optOutOptimizely();
            } else {
              optInOptimizely();
            }
          } else {
            reporter.error(`Failed to update CPRA preferences`, {trackingResponse, storageResponse});
            addToast({type: ToastType.ERROR, message: `Something went wrong updating preferences`});
          }
        },
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    loadIsGdpr().then((gdprData) => {
      this.updateGdprData(gdprData);
      gdprData.registerOnUpdateCallback(this.updateGdprData.bind(this));
      initOptimizely();
    });
  }

  updateGdprData({allowStorage, allowTracking}) {
    // CPRA requires that both storage + trackers are blocked. A user is only optedout to us "selling data" if they block both cookies and trackers.
    // Therefore if either is set, we consider them to be optedIn.
    const optStatus = allowStorage || allowTracking ? `in` : `out`;
    this.update({optStatus});
  }
}

defineAndMakeJsxFactory(`mp-cpra-preferences`, CPRAPreferences);
